import { DocumentTextIcon, TrashIcon } from "@heroicons/react/20/solid";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

const ReportPackRow = ({ reportPack, deletePack }) => {
	const navigate = useNavigate();

	const edit = () => {
		navigate(`/advisor/reports/reportPacks/${reportPack?.id}`);
	};

	return (
		<tr className="">
			<td>{reportPack?.name}</td>
			<td>{reportPack?.appliedOrgs.length}</td>
			<td>{reportPack?.reports.length}</td>
			<td className="text-right">
				<a
					className="btn btn-success"
					onClick={edit}
				>
					<DocumentTextIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
					<span style={{ float: "left" }}>Edit</span>
				</a>
				<a
					className="btn btn-danger ml-3"
					onClick={deletePack}
				>
					<TrashIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
					<span style={{ float: "left" }}>Delete</span>
				</a>
			</td>
		</tr>
	);
};

const mapStateToProps = (state) => {};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ReportPackRow);
